import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
interface PricingOfferProps {
  cartLink: string;
}
export const PricingOffer: React.FC<PricingOfferProps> = ({
  cartLink
}) => {
  return <section className="py-20 md:py-32 px-4 bg-gradient-to-b from-brand-rose to-brand-blush" data-id="element-132">
      <div className="max-w-5xl mx-auto" data-id="element-133">
        <div className="text-center mb-12" data-id="element-134">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-135">
            Haz Click Debajo Para Empezar Ahora:
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row max-w-4xl mx-auto border border-brand-gold/20" data-id="element-136">
          {/* Left: Mockup & Badge */}
          <div className="w-full md:w-5/12 bg-brand-cream p-8 md:p-12 flex items-center justify-center relative" data-id="element-137">
            <div className="absolute top-6 right-6 w-24 h-24 bg-brand-gold text-white rounded-full flex flex-col items-center justify-center shadow-lg transform rotate-12 z-10 border-4 border-white" data-id="element-138">
              <span className="text-2xl font-bold leading-none" data-id="element-139">-50%</span>
              <span className="text-sm font-bold" data-id="element-140">OFF</span>
            </div>

            <div className="relative w-full max-w-[320px] aspect-square shadow-2xl rounded-2xl overflow-hidden" data-id="element-141">
              <img src="https://cdn.magicpatterns.com/uploads/whZxBMNHLtAaGJNPNzMeNt/ChatGPT_Image_10_may_2026,_09_57_19_p.m..png" alt="Bonuses Exclusivos - Tu Transformación Emocional Completa" className="w-full h-full object-cover" data-id="element-142" />
            </div>
          </div>

          {/* Right: Pricing & CTA */}
          <div className="w-full md:w-7/12 p-8 md:p-12 flex flex-col justify-center" data-id="element-143">
            <div className="inline-block bg-emerald-100 text-emerald-800 px-4 py-1.5 rounded-full text-sm font-bold mb-6 w-fit" data-id="element-144">
              🎁 Oferta -50% OFF sólo 20 cupos
            </div>

            <div className="mb-8" data-id="element-145">
              <div className="text-gray-500 font-medium text-lg mb-2" data-id="element-146">
                Antes: <PriceDisplay basePriceARS={40000} strikeThrough data-id="element-147" />
              </div>
              <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-4" data-id="element-148">
                <span className="text-xl font-bold text-brand-wine" data-id="element-149">
                  PRECIO DE HOY:
                </span>
                <PriceDisplay basePriceARS={25990} className="text-4xl md:text-5xl font-serif font-bold text-brand-charcoal" data-id="element-150" />
              </div>
            </div>

            <CTAButton href={cartLink} fullWidth className="mb-6 py-5 text-xl" data-id="element-151">
              Obtener Acceso Instantáneo
            </CTAButton>

            <div className="text-center font-medium text-brand-wine mb-8 animate-pulse" data-id="element-152">
              ⚡ Últimos 3 Cupos en Oferta!
            </div>

            {/* Trust Elements */}
            <div className="border-t border-gray-100 pt-6 mt-auto" data-id="element-153">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-gray-500" data-id="element-154">
                <div className="flex items-center gap-2" data-id="element-155">
                  <Lock className="w-5 h-5 text-gray-400" data-id="element-156" />
                  <span data-id="element-157">Pago Seguro</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-158">
                  <ShieldCheck className="w-5 h-5 text-gray-400" data-id="element-159" />
                  <span data-id="element-160">Garantía 60 Días</span>
                </div>
              </div>

              <div className="flex items-center justify-center gap-4 mt-4 text-gray-400" data-id="element-161">
                <span className="font-bold border px-2 py-1 rounded text-xs" data-id="element-162">
                  VISA
                </span>
                <span className="font-bold border px-2 py-1 rounded text-xs" data-id="element-163">
                  MASTERCARD
                </span>
                <span className="font-bold border px-2 py-1 rounded text-xs" data-id="element-164">
                  MERCADO PAGO
                </span>
              </div>

              <p className="text-center text-xs mt-4" data-id="element-165">
                Pago único. SIN mensualidades.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};